;(function(window, $) {
    window.ns = window.ns || {};

    window.openShareDialog= function (url) {
        setTimeout( function () {
            window.open(url, 'share_dialog', 'width=700,height=500,left=200,top=100,location=no,directories=no,status=no,toolbar=no,menubar=no');
        },100);
        return false;
    };



    window.ns['blog-page'] = {
        init: function() {
            $('.js-history-back').click(function(e) {
                e.preventDefault();
                window.history.back();
            });

            // Top fixed menu
            var $menu = $('.page-menu');

            try {
                new Waypoint.Inview({
                    element: $('.page-menu'),
                    entered: function () {
                        $menu.removeClass('is-fixed');
                    },
                    exited: function () {
                        $menu.addClass('is-fixed');
                    }
                });
            } catch (e) {}

            var li = $('.news-listing-item');
            $.each(li, function(index, val) {
                /* iterate through array or object */
                var inview = new Waypoint.Inview({
                    element: val,
                    enter: function(direction) {
                        // console.log('Enter triggered with direction ' + direction)
                    },
                    entered: function(direction) {
                        // console.log('Entered triggered with direction ' + direction);
                        $(val).find('.news-listing-item_puplish-date').addClass('isVisible');
                    },
                    exit: function(direction) {
                        // console.log('Exit triggered with direction ' + direction)
                        $(val).find('.news-listing-item_puplish-date').removeClass('isVisible');
                    },
                    exited: function(direction) {
                        // console.log('Exited triggered with direction ' + direction)

                    }
                });
            });
        }
    };

	(function(){
		if (true) {

			var slider = $("#blogPageSlider").lightSlider({
				item:1,
				slideMargin:5,
				thumbItem:9,
				gallery:true,
				addClass:'page-slider',
				controls:false,
				pager:true,
				adaptiveHeight:false,
				thumbMargin: 10,
                responsive:[
                    {
                        breakpoint:800,
                        settings: {
                            thumbItem:7
                        }
                    },
                    {
                        breakpoint:600,
                        settings:{
                            gallery:false
                        }
                    }
                ],
				onSliderLoad:function(el){
                    var tl = window.innerWidth > 768 ? 9 : 5;
					var len = el[0].childElementCount;
					var html = 	'<div class="row page-slider-row">'+
												'<div class="gr-10 gr-12@tablet gr-12@mobile page-slider-desc"></div>'+
												'<div class="gr-2 hide@tablet hide@mobile text-right"><div class="main-slider_nav"><div style="" class="owl-prev">prev</div><span class="len"> <b class="cur">1</b><span> / </span><span class="total">'+len+'</span></span><div style="" class="owl-next">next</div></div></div>'+
											'</div>';
					$(el).parent().after(html);
					$('.main-slider_nav .owl-next').on('click', function(e){
						slider.goToNextSlide();
					});
					$('.main-slider_nav .owl-prev').on('click', function(e){
						slider.goToPrevSlide();
					});


					setTimeout(function(){
						el.addClass('is-va').css({
							'height':el.find('img').eq(0).height() + 'px'
						});
					}, 500);

					(function() {
                        var thumbsWrap = $('.lSPager.lSGallery')[0];
                        if(!thumbsWrap){return false;}
                        var thumbsNodes = thumbsWrap.childNodes;
                        var thumbWidth = thumbsNodes[0].offsetWidth;


							for (var i = 0; i < thumbsNodes.length; i++) {
								var cl = i == 0 ? 'active': '';

								var desc = el[0].children[i].dataset.description ? el[0].children[i].dataset.description : '';
								$('.page-slider-desc').append('<div class="page-slider-desc-item '+cl+'"><div class="page-slider-desc-item-inner">'+desc+'</div></div>');
							};




						if (el.parents('.main-slider').width() < $(thumbsWrap).width() ) {
							var dotsLength =  Math.ceil( $(thumbsWrap).width() / el.parents('.main-slider').width()  );


							for (var i = 0; i < dotsLength; i++) {
								var cl = i == 0 ? 'active': '';
								$('.main-slider_dots').append('<div class="owl-dot '+cl+'" data-index="'+(i)+'"></div>');
							};

							$('.main-slider_dots .owl-dot').on('click', function(e){
								if ($(this).data('index') > 0) {
									// var w = el.parents('.main-slider').width()  * ($(this).data('index'));
                                    var w = (tl * (parseInt($('.main-slider .lSPager.lSGallery li').css('width')) + parseInt($('.main-slider .lSPager.lSGallery li').css('margin-right')))) * $(this).data('index');
								}else{
									w=0;
								}

								$('.lSSlideOuter .lSPager.lSGallery').css({
									'transform': 'translate3d(-' + w + 'px, 0px, 0px)'
								});
								$('.main-slider_dots .owl-dot').removeClass('active');
								$(this).addClass('active');
							});

						}

                        (function(){
                            var tc = new Hammer(thumbsWrap);
                            var dots = $('.main-slider_dots .owl-dot');
                            tc.on('swipeleft', function(){
                                if (dots.filter('.active').index()+1 < dots.length)
                                    dots.eq(dots.filter('.active').index()+1).click();
                            }).on('swiperight', function(){
                                if (dots.filter('.active').index() !== 0)
                                    dots.eq(dots.filter('.active').index()-1).click();
                            });
                        }());

					}());

					

					
					$('.page-slider-desc').height($('.page-slider-desc-item').height());

					$.each($('.page-slider-desc-item'), function(index, val) {
						if( ( $(val.children[0]).height() > $('.page-slider-desc').height() )== true ){
							$('.page-slider-desc').height($(val.children[0]).height());
						}
					});

					if ($('.page-slider-desc').height() < 2) {
						$('.page-slider-desc').parent().removeClass('page-slider-row');
					}

				},
				onAfterSlide:function(el){
					var actInd = $(el).find('.active').index();
					var thumbsNodes =  $('.lSPager.lSGallery')[0].childNodes;
					var dots = $('.main-slider_dots .owl-dot');

					var inview = Math.floor( thumbsNodes.length / dots.length );
                    var dotIdex = ((Math.floor(actInd  / inview) ) > 0) ? (Math.floor(actInd  / inview) ) : 0 ;
                    if (dots.length != dotIdex) {
                        $('.main-slider_dots .owl-dot').removeClass('active').eq(dotIdex).addClass('active');
                    }
					$('.page-slider-desc > *').removeClass('active').eq(actInd).addClass('active');
					$('.main-slider_nav .len .cur').html( actInd+1);

				}
			}); 
		}
		
	}());



})(window, jQuery);
